import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { isEmpty, get, camelCase } from "lodash";
import { Button, Form } from "react-bootstrap";
import {
  ManageEligibilityLayout,
  LoaderWrapper,
  CsplTable as Table,
  FieldDropSide,
  DatePicker,
  SearchableList,
  SliderPanel,
} from "../../../components";
import {
  manageEligibilityFormNames,
  MANAGE_ELIGIBILITY_ROUTES,
  getPathWithParam,
  formFields,
  getFlowBasedFormValues,
  usDateFormat,
  EMPLOYEE_RECORDS_TO_FETCH,
} from "../../../utils";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import {
  getCompaniesList,
  getVestingSummaryReport,
  getPlanList,
} from "../../../services";
import {
  manageEligibilityStore,
  setManagePageLevelData,
} from "../../../contexts";
import { Formik, Field } from "formik";
import { CSVLink } from "react-csv";
import moment from "moment";
import permissions from "../../../mocks/menuPermissions.json";
import authService from "../../../components/api-authorization/AuthorizeService";
import InfiniteScroll from "react-infinite-scroller";
import RunVestingProcessSlider from "./RunVestingProcessSlider";

const initialValues = {};

const columns = [
  {
    label: "Company Name",
    className: "column-companyName",
    columnName: "companyName",
  },
  {
    label: "Plan Details",
    className: "column-planId",
    columnName: "rkPlanNumber",
  },
  {
    label: "Vesting Updated Employee",
    className: "column-updatedEmployee",
    columnName: "vestingUpdatedEmployee",
  },
  {
    label: "Process Date",
    className: "column-processDate",
    columnName: "processDate",
  },
];

const planOptions = ["Plan ID", "Plan Name"];

const VestingSummaryReportsContainer = (props) => {
  const { menu, subMenu } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const { flow } = useRouterParams();
  const { state, dispatch } = useContext(manageEligibilityStore);
  const [isLoading, setIsLoading] = useState(false);
  const [planList, setPlanList] = useState([]);
  const allOption = { label: "All", value: null };
  const [vestingSummaryReport, setVestingSummaryReport] = useState([]);
  const [planOption, setPlanOption] = useState(0);
  const [append, setAppend] = useState(false);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [total, setTotal] = useState();

  const { response: companies } = useRequest({
    method: getCompaniesList,
    payload: 1, //TenantId. HardCoding should be removed
    defaultResponse: [],
  });
  const formName = manageEligibilityFormNames.ELIGIBILITY_SUMMARY_FILTER;
  const fields = formFields[formName];
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const buttons = [];

  const onFormSubmit = (values) => {
    dispatch(
      setManagePageLevelData({
        formName: formName,
        fieldData: values,
      })
    );
  };
  const [apiRequest, setApiRequest] = useState({
    companyId: null,
    planId: null,
    from: 0,
    to: parseInt(EMPLOYEE_RECORDS_TO_FETCH),
  });

  useDeepEffect(() => {
    setIsLoading(true);
    getVestingSummaryReport(apiRequest)
      .then((response) => {
        setTotal(response.totalCount);

        if (
          response?.vestingSummaryReportData.length < EMPLOYEE_RECORDS_TO_FETCH
        )
          setStopInfiniteScroll(true);
        if (append)
          setVestingSummaryReport((vestingSummaryReport) => {
            return [
              ...vestingSummaryReport,
              ...response.vestingSummaryReportData,
            ];
          });
        else {
          setVestingSummaryReport(response.vestingSummaryReportData);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        //Handle Errors
        setIsLoading(false);
      });
  }, [apiRequest]);

  const onFilter = (values) => {
    setIsLoading(true);
    setVestingSummaryReport([]);
    setApiRequest({
      ...apiRequest,
      companyId: parseInt(values.companyId),
      planId: values.planId,
      fromDate: values.startDate,
      toDate: values.endDate,
      from: 0,
      to: parseInt(EMPLOYEE_RECORDS_TO_FETCH),
    });
    setStopInfiniteScroll(false);
  };
  const onViewButtonClick = () => {
    setModalOpen(!isModalOpen);
  };

  return (
    <ManageEligibilityLayout buttons={buttons}>
      <div className="eligibility-container">
        <CSVLink data={vestingSummaryReport}>
          {/* <FontAwesomeIcon icon={faShareSquare} color="#212529" /> */}
          Export
        </CSVLink>
      </div>

      <LoaderWrapper isLoading={isLoading}>
        <div className="w-100">
          <div className="d-flex w-100 align-items-center justify-content-between mb-4">
            <div className="m-0 plan-heading font-weight-500">
              Summary Reports
            </div>
            <div className="m-0 plan-heading font-weight-500">
              {permissions[roleName][menu + "SubMenu"][
                camelCase(subMenu)
              ]?.includes("C") &&
                permissions[roleName][menu + "SubMenu"][
                  camelCase(subMenu)
                ]?.includes("U") && (
                  <Button onClick={onViewButtonClick}>
                    Run Vesting Process
                  </Button>
                )}
            </div>
          </div>

          <Formik
            initialValues={{
              ...initialValues,
              ...getFlowBasedFormValues(get(state, formName, {}), flow),
            }}
            onSubmit={onFormSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };
              const onCompanyChange = (value, plan) => {
                setFieldValue(
                  fields.companyName,
                  value || value === null ? "All" : companies[value].name
                );
                if (value !== null) {
                  setFieldValue(fields.companyName, companies[value].name);
                  setFieldValue(fields.companyId, companies[value].id);
                  setFieldValue(fields.rkPlanNumber, "All");
                  setFieldValue(fields.planName, "All");
                  getPlanList(companies[value].id)
                    .then((response) => {
                      setPlanList(response);
                    })
                    .catch((error) => {
                      //Handle Error
                    });
                } else {
                  setFieldValue(fields.companyId, 0);
                }
              };

              const onPlanChange = (value, plan) => {
                setFieldValue(
                  fields.planName,
                  value || value === null ? "All" : planList[value].name
                );
                setFieldValue(
                  fields.rkPlanNumber,
                  value || value === null ? "All" : planList[value].rkPlanNumber
                );
                setFieldValue(
                  fields.planId,
                  value || value === null ? 0 : planList[value].id
                );
                if (value !== null) {
                  setFieldValue(fields.planName, planList[value].name);
                  setFieldValue(
                    fields.rkPlanNumber,
                    planList[value].rkPlanNumber
                  );
                  setFieldValue(fields.planId, planList[value].id);
                }
              };
              return (
                <Form
                  autoComplete="off"
                  className="h-100"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex">
                    <div className="d-flex mr-2 border-cut">
                      <label className="label-sort br-0">Company</label>
                      <Field
                        size="sm"
                        name={fields.companyName}
                        value={values[fields.companyName]}
                        direction="bottom"
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={
                              companies && [
                                allOption,
                                ...companies.map((company, index) => ({
                                  label: company.name,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => onCompanyChange(value, null)}
                            selectedValue={values[fields.companyName]}
                          />
                        }
                        component={FieldDropSide}
                      />

                      <div className="d-flex ml-2 mr-2 census-border-cut eligibility-placeholder-color">
                        <div className="br-0">
                          <Field
                            size="sm"
                            value={planOptions[planOption]}
                            placeholder="Plan ID"
                            direction="bottom"
                            popupContent={
                              <SearchableList
                                label="Plan ID"
                                options={planOptions?.map((option, index) => {
                                  return {
                                    label: option,
                                    value: index,
                                  };
                                })}
                                onSelect={(value) => setPlanOption(value)}
                                selectedValue={planOption}
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div>
                        <div className="bl-0">
                          {planOption === 1 && (
                            <Field
                              size="sm"
                              name={fields.planName}
                              value={values[fields.planName]}
                              direction="bottom"
                              popupContent={
                                <SearchableList
                                  label="Select Plan"
                                  options={
                                    planList && [
                                      allOption,
                                      ...planList.map((plan, index) => ({
                                        label: plan.name,
                                        value: index,
                                      })),
                                    ]
                                  }
                                  onSelect={(value) => onPlanChange(value)}
                                  selectedValue={values[fields.planName]}
                                />
                              }
                              component={FieldDropSide}
                            />
                          )}
                          {planOption === 0 && (
                            <Field
                              size="sm"
                              name={fields.rkPlanNumber}
                              value={values[fields.rkPlanNumber]}
                              direction="bottom"
                              popupContent={
                                <SearchableList
                                  label="Select Plan"
                                  options={
                                    planList && [
                                      allOption,
                                      ...planList.map((plan, index) => ({
                                        label: plan.rkPlanNumber,
                                        value: index,
                                      })),
                                    ]
                                  }
                                  onSelect={(value) => onPlanChange(value)}
                                  selectedValue={values[fields.rkPlanNumber]}
                                />
                              }
                              component={FieldDropSide}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="d-flex mr-2 border-cut">
                        <label className="label-sort br-0">Date range</label>
                        <Field
                          size="sm"
                          name={fields.startDate}
                          value={usDateFormat(values[fields.startDate])}
                          isDatePicker
                          placeholder="From"
                          direction="bottom"
                          onClear={() => onDaySelected(fields.startDate, null)}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.startDate, value)
                              }
                              value={values[fields.startDate]}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="mr-4 ml-4">
                        <Field
                          size="sm"
                          name={fields.endDate}
                          placeholder="To"
                          value={usDateFormat(values[fields.endDate])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => onDaySelected(fields.endDate, null)}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.endDate, value)
                              }
                              value={values[fields.endDate]}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                    <Button
                      onClick={() => {
                        onFilter(values);
                      }}
                      className="ml-2 sort-button"
                    >
                      Go
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>

          <div className="text-right mr-4 mb-10">
            <p>
              {" "}
              {vestingSummaryReport.length != 0
                ? `${vestingSummaryReport.length}/${total}`
                : 0}{" "}
              Records{" "}
            </p>
          </div>

          <div className="vesting-summary-table">
            <Table>
              <Table.Thead>
                <Table.Tr>
                  {columns.map((item, index) => {
                    return (
                      <Table.Th key={index} className={item.className}>
                        {item.label}
                      </Table.Th>
                    );
                  })}
                </Table.Tr>
              </Table.Thead>

              <Table.Tbody>
                {vestingSummaryReport.length === 0 && (
                  <div style={{ textAlign: "center" }}>No data available</div>
                )}
                <InfiniteScroll
                  pageStart={0}
                  loadMore={() => {
                    setAppend(true);
                    setApiRequest((apiRequest) => {
                      return {
                        ...apiRequest,
                        from: vestingSummaryReport?.length,
                      };
                    });
                  }}
                  hasMore={!stopInfiniteScroll}
                  initialLoad={false}
                  threshold={100}
                  useWindow={false}
                  loader={
                    vestingSummaryReport.length != 0 && (
                      <div className="loader" key={0}>
                        Loading ...
                      </div>
                    )
                  }
                >
                  {vestingSummaryReport?.map((source, index) => {
                    return (
                      <Table.Tr key={index}>
                        <Table.Td className="column-companyName">
                          {source.companyName}
                        </Table.Td>
                        <Table.Td className="column-planId d-flex flex-column">
                          <div>{source.planName}</div>
                          <div>ID:{source.rkPlanNumber}</div>
                        </Table.Td>

                        <Table.Td className="column-updatedEmployee">
                          <Link
                            to={getPathWithParam({
                              path: `${MANAGE_ELIGIBILITY_ROUTES.NEW_EMPLOYEE_VESTING_REPORT}`,
                              // pathParam: [flow],
                              queryParam: `?planId=${source.planID}&processId=${source.id}`,
                            })}
                          >
                            {source.employeeCount}
                          </Link>
                        </Table.Td>

                        <Table.Td className="column-processDate">
                          {usDateFormat(source.processDate) +
                            " " +
                            moment(new Date(source.processDate)).format(
                              "HH:mm:ss"
                            )}
                        </Table.Td>
                      </Table.Tr>
                    );
                  })}
                </InfiniteScroll>
              </Table.Tbody>
            </Table>
          </div>
        </div>
      </LoaderWrapper>

      <SliderPanel
        isOpen={isModalOpen}
        size="30"
        onClose={() => setModalOpen(false)}
        backdropClicked={false}
        showCancel={true}
        showHeader={true}
        header={"Run Vesting Process"}
        headerClass={"plan-sub-heading"}
        showSeparator={true}
      >
        <RunVestingProcessSlider
          onCancel={onViewButtonClick}
          onSubmitted={onViewButtonClick}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setModalOpen={setModalOpen}
        />
      </SliderPanel>
    </ManageEligibilityLayout>
  );
};

export default VestingSummaryReportsContainer;
